import { Field, Formik } from "formik";
import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Put from "../../api/Put";
import { APPOINTMENT_UPDATE } from "../../api/Routes";
import SimpleLoad from "../../loader/SimpleLoad";
import { toast } from "react-toastify";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import {canEditDoctor} from "../../utils/isDoctor";

function DoctorAdditionalNotes({t, citaID, auth, additionalNotes, readOnly, cita}){
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)
    const [initialValues, setInitialValues] = useState({
        id: citaID,
        additionalNotes: additionalNotes ? additionalNotes : ''
    })




    return(
        <div className="p-3 pt-4 position-relative">
            { readOnly ? additionalNotes :
                <Row className="mt-3">
                    <Col>
                        <Formik initialValues={ initialValues }
                                onSubmit={(values, { setSubmitting, setFieldValue }) => {
                                    Put({url: APPOINTMENT_UPDATE, data: values, access_token: auth.data.access_token, header: true})
                                        .then(resp => {
                                            setSubmitting(false)
                                            toast.success("Acción exitosa", {autoClose: 3000})
                                        })
                                        .catch(error => {
                                            setSubmitting(false)
                                            setShowModalError(true)
                                            if(error.response){
                                                setErrorServer(error.response)
                                            }
                                        })
                                }}>{({
                                         values,
                                         errors,
                                         touched,
                                         handleChange,
                                         handleBlur,
                                         handleSubmit,
                                         isSubmitting,
                                         setFieldValue,
                                         resetForm
                                     })=>(
                            <Form onSubmit={handleSubmit}  className='mt-3'>
                                { isSubmitting && <SimpleLoad /> }
                                <Row>
                                    <Col xs="12" md="12">
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary"> Notas aclaratoria </Form.Label>
                                            <Field
                                                type="text"
                                                className={`form-control input-form ${errors.additionalNotes && 'error'}`}
                                                name="additionalNotes"
                                            />
                                            { errors.additionalNotes && <div className="invalid-feedback d-block">{errors.additionalNotes}</div> }
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {cita.finished &&
                                <Row className="grupoBotones">
                                    <Col className="text-right">
                                        <Button variant="outline-success" className="ok-buttom" type="submit"> {t('guardar')} </Button>{' '}
                                    </Col>
                                </Row>}
                            </Form>
                        )}
                        </Formik>
                    </Col>
                </Row>}
            <ComponentModalErrorSever
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </div>
    )

}

export default withTranslation()(DoctorAdditionalNotes)